import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

/** April 2026 toolkit */
export const thrivingAtWorkToolkitMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.THRIVING_AT_WORK,
  iFrameSrcUrl: '/work',
  micrositeUrl: 'work',
  title: {
    id: 'thrivingAtWorkToolkit.title',
    defaultMessage: 'Thriving at Work',
    description: 'Microsite page title',
  },
  featureFlag: 'isThrivingAtWorkToolkitEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_REGISTRATION },
    { key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        webinarLink: '/secure/index/essentials/events/steady-striving-for-sustainable-success',
      },
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_FORKED_TRIAGE },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_WEBINAR_EVENTS },
  ],
  page: '202604 work',
  trackUTMParams: {
    utm_campaign: 'Apr426',
  },
  customMixpanelEventProps: {
    toolkit_topic: 'thrivingatwork',
  },
  shouldHideForInternational: true,
}
